import React, { useState } from 'react';
import { sizes } from 'src/styles/Media.styled';
import DownArrowFilter from 'src/assets/images/DownArrowFilter.svg';
import { isMobileDevice } from 'src/utils/util';
import { useSelector } from 'react-redux';
import { convertTime24To12 } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import {
    AccountGridContainer,
    AccountGrid,
    ImageContainer,
    NotesContainer,
    MainContainerItems,
    Subtitle,
    Title,
    ImageBox,
    MainTitle,
    ImageWrapper,
    VerticalLineSeperator,
    Bar,
} from './reviewAndSubmitNotes.styled';
import {
    
    formatDateddmmmyy,
    getDisplayDate,
} from 'src/utils/dateUtils';
import Edit from 'src/assets/images/Edit.svg';
import FlagRed from 'src/assets/images/Alert icon 1.svg';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { isMobileView } from '../../../pages/scheduleSurgery/components/surgery/cartSection/cartUtils';
import { logErrorToConsole } from 'src/utils/util';
const ReviewAndSubmitNotes = ({
   
    isSubmitClicked,
    isFromEquity,
    isFromConsignmentAdd,
    isFromConsignmentBilling,
    isFromSurgery,
    isFromReportUsage,
    setViewSurgeryNotes,
    reportPaymentGridData,
    isReportPayment,
    isTransferSurgery,
    // replenCount,
    // setReplenCount,
}) => { 
    const [expandedCard, setExpandedCard] = useState({
        itemDetails: true,
    });

    const [expandedCard1, setExpandedCard1] = useState({
        itemDetails: true,
    });

    // const usageOrderSubmission = useSelector(
    //     (state) => state.reportUsageRootReducer.usageOrderSubmission
    // );

    const replenDetailsData = useSelector(
        (state) => state.gridDataReducer.gridData
    );
    const reportUsageFormObj = useSelector(
        (state) => state.reportUsageRootReducer.reportUsageObject
    );

    // const orderStatus = useSelector(
    //     (state) => state.reportUsageRootReducer.orderStatus
    // );

    // const isUsagedSubmittedSuccessfully =
    //     (usageOrderSubmission && usageOrderSubmission.statusCode === '200') ||
    //     (Object.keys(orderStatus).length > 0 &&
    //         orderStatus.status &&
    //         orderStatus.status.includes('Usage Order Submitted Successfully'));

    const [expandedCard2, setExpandedCard2] = useState({
        itemDetails: true,
    });

    // const restrictReviewScreen = useSelector(
    //     (state) => state.reportUsageRootReducer.restrictReviewScreen
    // );
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );

    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );

    const [replenWarning] = useState(false);

    const { notesData, displayName } = useSelector((state) => ({
        notesData: state.HeaderNotesReducer,
        displayName: state.loginReducer.hybrisUserDetails.displayName,
    }));

    const [notesData1, setNotesData1] = useState([]);
    const [notesData2, setNotesData2] = useState([]);
    const [replenCountCons, setReplenCountCons] = useState(-1);
    const [replenCountUsage, setReplenCountUsage] = useState(-1);

    //expanded card
    const toggleCard = (name, value) => {
        setExpandedCard({
            ...expandedCard,
            [name]: value,
        });
    };

    const toggleCard1 = (name, value) => {
        setExpandedCard1({
            ...expandedCard1,
            [name]: value,
        });
    };

    const toggleCard2 = (name, value) => {
        setExpandedCard2({
            ...expandedCard2,
            [name]: value,
        });
    };
    useEffectWithErrorLogging(() => {
        if (isFromConsignmentBilling) {
            let replenDetails = replenDetailsData.filter(
                (data) => data.isReplenish === true
            );
            // let totalReplenRecords = Object.keys(replenDetails).length;
            setReplenCountCons(
                replenDetails?.length > 0 ? replenDetails.length : 0
            );
        }
    }, [replenDetailsData]);

    useEffectWithErrorLogging(() => {
        if (!isReportPayment && isFromReportUsage) {
            let pr = reportUsageFormObj?.products?.filter((item) => {
                return item.isReplenish === true;
            });
            let chBundle = reportUsageFormObj?.products?.filter((it) => {
                return it.bundleItem;
            });
            let bundlePr = chBundle.map((ele) => {
                let replenBundleItem = ele.bundleItem.filter((item) => {
                    return item.isReplenish === true;
                });
                return replenBundleItem.length;
            });
            setReplenCountUsage(
                pr?.length > 0 || bundlePr.includes(1)
                    ? pr.length
                        ? pr.length
                        : bundlePr.includes(1)
                    : 0
            ); 
        }
    }, [reportUsageFormObj]);

    useEffectWithErrorLogging(() => {
        if (isReportPayment) {
            let pr = reportPaymentGridData?.filter((item) => {
                return item.isReplenish === true;
            });
            setReplenCountUsage(pr?.length > 0 ? pr.length : 0); 
        }
    }, [reportPaymentGridData]);

    useEffectWithErrorLogging(() => {
        if (isSubmitClicked) {
            setExpandedCard({
                ...expandedCard,
                itemDetails: false,
            });
        } else if (window.innerWidth > sizes.mobileDevice) {
            setExpandedCard({
                ...expandedCard,
                itemDetails: true,
            });
        } else if (window.innerWidth <= sizes.mobileDevice) {
            setExpandedCard({
                ...expandedCard,
                itemDetails: false,
            });
        }
    }, []);

    useEffectWithErrorLogging(() => {
        if (isSubmitClicked) {
            setExpandedCard2({
                ...expandedCard2,
                itemDetails: false,
            });
            setExpandedCard1({
                ...expandedCard1,
                itemDetails: false,
            });
        } else if (window.innerWidth > sizes.mobileDevice) {
            setExpandedCard2({
                ...expandedCard2,
                itemDetails: true,
            });
            setExpandedCard1({
                ...expandedCard1,
                itemDetails: true,
            });
        } else if (window.innerWidth <= sizes.mobileDevice) {
            setExpandedCard2({
                ...expandedCard2,
                itemDetails: false,
            });
            setExpandedCard1({
                ...expandedCard1,
                itemDetails: false,
            });
        }
    }, []);

    useEffectWithErrorLogging(() => {
        if (isFromEquity) {
            let equityNotesData = notesData?.equityNotes[0]?.equityNotes
                ? notesData?.equityNotes[0]?.equityNotes.sort((a, b) => {
                    return (
                        new Date(b.creationDate) - new Date(a.creationDate)
                    );
                })
                : [];
            setNotesData1(
                equityNotesData.sort((a, b) => {
                    return new Date(b.creationDate) - new Date(a.creationDate);
                })
            );
        } else if (isFromConsignmentAdd) {
            let consignmentAddData = notesData?.consignmentAddNotes[0]
                ?.consignmentAddNotes
                ? notesData?.consignmentAddNotes[0]?.consignmentAddNotes
                : [];
            setNotesData1(
                consignmentAddData.sort((a, b) => {
                    return new Date(b.creationDate) - new Date(a.creationDate);
                })
            );
        } else if (isFromConsignmentBilling) {
            let consignmentBillingData = notesData?.consignmentBillingNotes[0]
                ?.consignmentBillingNotes
                ? notesData?.consignmentBillingNotes[0]?.consignmentBillingNotes
                : [];
            let consignmentReplenishmentData = notesData
                ?.consignmentBillingNotes[0]?.consignmentReplenishmentNotes
                ? notesData?.consignmentBillingNotes[0]
                    ?.consignmentReplenishmentNotes
                : [];
            setNotesData1(
                consignmentBillingData.sort((a, b) => {
                    return new Date(b.creationDate) - new Date(a.creationDate);
                })
            );
            // if (consignmentReplenishmentData?.length > 0 && replenCountCons > 0) {
            //     setReplenWarning(false);
            // } else if (
            //     consignmentReplenishmentData?.length > 0 &&
            //     !(replenCountCons > 0)
            // ) {
            //     setReplenWarning(true);
            // }
            setNotesData2(
                consignmentReplenishmentData.sort((a, b) => {
                    return new Date(b.creationDate) - new Date(a.creationDate);
                })
            );
        } else if (isFromReportUsage) {
            let reportUsageData = notesData?.reportUsageNotes[0]
                ?.reportUsageNotes
                ? notesData?.reportUsageNotes[0]?.reportUsageNotes
                : [];
            let reportReplenishmentData = notesData?.reportUsageNotes[0]
                ?.reportReplenishmentNotes
                ? notesData?.reportUsageNotes[0]?.reportReplenishmentNotes
                : [];
            setNotesData1(
                reportUsageData.sort((a, b) => {
                    return new Date(b.creationDate) - new Date(a.creationDate);
                })
            );
            // if (reportReplenishmentData?.length > 0 && (replenCountUsage > 0)) {
            //     setReplenWarning(false);
            // } else if (reportReplenishmentData?.length > 0 && replenCountUsage <= 0) {
            //     setReplenWarning(true);
            // }
            setNotesData2(
                reportReplenishmentData.sort((a, b) => {
                    return new Date(b.creationDate) - new Date(a.creationDate);
                })
            );
        } else if (isFromSurgery && !isTransferSurgery) {
            let customerNotes =
                notesData?.surgeryNotes[0]?.customerNotes.filter(
                    ({ isReservationSetNote, typeOfNote }) => {
                        if (
                            isReservationSetNote === true &&
                            typeOfNote === 'BatchReservationNotes'
                        ) {
                            return false;
                        } else {
                            return true;
                        }
                    }
                )
                    ? notesData?.surgeryNotes[0]?.customerNotes
                        .filter(({ isReservationSetNote, typeOfNote }) => {
                            if (
                                isReservationSetNote === true &&
                                typeOfNote === 'BatchReservationNotes'
                            ) {
                                return false;
                            } else {
                                return true;
                            }
                        })
                        .sort((a, b) => {
                            return (
                                new Date(b.creationDate) -
                                new Date(a.creationDate)
                            );
                        })
                    : [];
            let surgeryNotes = notesData?.surgeryNotes[0]?.surgeryNotes
                ? notesData?.surgeryNotes[0]?.surgeryNotes.sort((a, b) => {
                    return (
                        new Date(b.creationDate) - new Date(a.creationDate)
                    );
                })
                : [];
            setNotesData1(
                customerNotes.sort((a, b) => {
                    return new Date(b.creationDate) - new Date(a.creationDate);
                })
            );
            setNotesData2(
                surgeryNotes.sort((a, b) => {
                    return new Date(b.creationDate) - new Date(a.creationDate);
                })
            );
        } else if (isFromSurgery && isTransferSurgery) {
            let customerNotes =
                notesData?.surgeryNotes[0]?.customerNotes.filter(
                    ({ isReservationSetNote, typeOfNote }) => {
                        if (
                            isReservationSetNote === true &&
                            typeOfNote === 'BatchReservationNotes'
                        ) {
                            return false;
                        } else {
                            return true;
                        }
                    }
                )
                    ? notesData?.surgeryNotes[0]?.customerNotes
                        .filter(({ isReservationSetNote, typeOfNote }) => {
                            if (
                                isReservationSetNote === true &&
                                typeOfNote === 'BatchReservationNotes'
                            ) {
                                return false;
                            } else {
                                return true;
                            }
                        })
                        .filter((note) => {
                            return (
                                note.isNew == true ||
                                note.isReservationSetNote == true
                            );
                        })
                        .sort((a, b) => {
                            return (
                                new Date(b.creationDate) -
                                new Date(a.creationDate)
                            );
                        })
                    : [];
            let surgeryNotes = notesData?.surgeryNotes[0]?.surgeryNotes
                ? notesData?.surgeryNotes[0]?.surgeryNotes
                    .filter((note) => {
                        return note.isNew == true;
                    })
                    .sort((a, b) => {
                        return (
                            new Date(b.creationDate) -
                            new Date(a.creationDate)
                        );
                    })
                : [];
            setNotesData1(
                customerNotes.sort((a, b) => {
                    return new Date(b.creationDate) - new Date(a.creationDate);
                })
            );
            setNotesData2(
                surgeryNotes.sort((a, b) => {
                    return new Date(b.creationDate) - new Date(a.creationDate);
                })
            );
        }
    }, [notesData]);
 

    const { t } = useTranslation();

    // useEffectWithErrorLogging(()=>{
    //     let flag = notesData1?.length>0 || notesData2?.length>0;
    //     setExpandedCard(flag);
    // },[notesData2,notesData1])

    return (
        !isSubmitClicked ? true : notesData1.length > 0 || notesData2.length > 0
    ) ? (
        window.innerWidth > sizes.mobileDevice ? (
            <AccountGridContainer
                container
                justifyContent={'space-between'}
                direction="row"
                isFromEquity={isFromEquity}
                isFromConsignmentBilling={isFromConsignmentBilling}
            >
                <AccountGrid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    mobile={12}
                >
                    <MainTitle
                        id={`review-and-submit-notes-main-title-${isFromEquity ? 'equity' : isFromConsignmentAdd ? 'consignment-add' : isFromConsignmentBilling ? 'consignment-billing' : isFromReportUsage ? 'report-usage' : isFromSurgery ? 'surgery' : ''}`}
                        onClick={() =>
                            toggleCard('itemDetails', !expandedCard.itemDetails)
                        }
                    >
                        <>
                            {isFromEquity || isFromConsignmentAdd
                                ? t('ConsignmentAdd.notes.notes')
                                : isFromReportUsage || isFromConsignmentBilling
                                    ? t('reportUsage.customerCareNotes')
                                    : t(
                                        'scheduleSurgery.surgery.SurgeryReviewAndSuccess.surgeryNotes'
                                    )}
                        </>
                        <ImageBox  style={{ marginRight: isFromConsignmentBilling && (window.innerWidth >= sizes.mobileDevice) ? '-4px' : isFromConsignmentAdd ? isCondensedView ? '15px' : '0':'' }}
                            mbMargin = {isFromConsignmentAdd && !isSubmitClicked ? '0px 15px 0px 0px'
                             : '0px 20px 0px 0px'}
                         >
                            {isSubmitClicked ? (
                                // || isUsagedSubmittedSuccessfully || !restrictReviewScreen
                                ''
                            ) : (
                                <ImageWrapper padding={isFromEquity || isFromConsignmentBilling ? '0' : isCondensedView && (isFromReportUsage || isFromSurgery ? '2px' : '17px')}
                                    style={{
                                        marginRight: (notesData1.length > 0 || notesData2.length > 0)
                                            ? isFromSurgery ? '15px' : isFromConsignmentBilling ? '14px' : isFromEquity ? '20px' : isFromConsignmentAdd ? '18px' : isFromReportUsage ? '15px' : ''
                                            : isFromSurgery ? '31px' : isFromConsignmentBilling ? '30px' : isFromEquity ? '38px' : isFromConsignmentAdd? isMobileDevice()?'36px':'40px': isFromReportUsage ? '30px' : ''
                                    }}
                                    
                                >
                                    <img
                                        id={`review-and-submit-notes-edit-icon-${isFromEquity ? 'equity' : isFromConsignmentAdd ? 'consignment-add' : isFromConsignmentBilling ? 'consignment-billing' : isFromReportUsage ? 'report-usage' : isFromSurgery ? 'surgery' : ''}`}
                                        src={Edit}
                                        onClick={() => {
                                            try {
                                            setViewSurgeryNotes(true);

                                            // dispatch(
                                            //     setProgressBarCurrentStep(
                                            //         ORDEREQUITYSTEPS[1]
                                            //     )
                                            // );
                                            // dispatch(
                                            //     setProgressBarStatus(
                                            //         ORDEREQUITYSTEPS[1]
                                            //     )
                                            // );
                                            } catch (error) {
                                               logErrorToConsole(error);
                                            }
                                        }}
                                    ></img>
                                </ImageWrapper>
                            )}
                            {(notesData1.length > 0 || notesData2.length > 0) && (
                                <ImageContainer
                                    id='review-and-submit-notes-down-arrow-icon'
                                    src={DownArrowFilter}
                                    alt="down-arrow"
                                    isExpanded={expandedCard.itemDetails}
                                    onClick={() =>
                                        toggleCard(
                                            'itemDetails',
                                            !expandedCard.itemDetails
                                        )
                                    }
                                    style={{
                                        marginTop: isMobileDevice()
                                            ? ''
                                            : '3px',
                                        marginLeft: isFromConsignmentBilling
                                            ? 'none'
                                            : !isFromSurgery && '0px',
                                        width:
                                            (isFromEquity ||
                                                isFromConsignmentAdd) &&
                                                !isMobileDevice()
                                                ? '18px'
                                                : isFromConsignmentBilling
                                                    ? 'auto'
                                                    : '',
                                        height:
                                            (isFromEquity ||
                                                isFromConsignmentAdd) &&
                                                !isMobileDevice()
                                                ? '25px'
                                                : '',
                                        display: 'flex',
                                        // marginRight: 
                                        //         isFromConsignmentBilling
                                        //         ? '4px'
                                        //         : ''
                                        marginRight: isFromConsignmentBilling
                                            ? '4px'
                                            : ( isFromConsignmentAdd && !isSubmitClicked ) ? '4px' 
                                            : ( isFromConsignmentAdd && isSubmitClicked ) ? '16px'
                                            : '',
                                        //     window.innerWidth > sizes.mobileDevice
                                        //         ? '10px'
                                        //         : '0px',
                                    }}
                                />
                            )}
                        </ImageBox>
                    </MainTitle>
                </AccountGrid>
                {expandedCard.itemDetails ? (
                    <>
                        <AccountGrid
                            item
                            xs={isFromEquity || isFromConsignmentAdd ? 12 : 12}
                            sm={isFromEquity || isFromConsignmentAdd ? 12 : 6}
                            md={isFromEquity || isFromConsignmentAdd ? 12 : 6}
                            lg={isFromEquity || isFromConsignmentAdd ? 12 : 6}
                            xl={isFromEquity || isFromConsignmentAdd ? 12 : 6}
                            mobile={
                                isFromEquity || isFromConsignmentAdd ? 12 : 6
                            }
                            style={{
                                display:
                                    notesData1?.length <= 0 ? 'none' : 'flex',
                            }}
                        >
                            <NotesContainer
                                style={{
                                    display:
                                        notesData1?.length <= 0 ? 'none' : null,
                                }}
                            >
                                <Title>
                                    {isFromEquity || isFromConsignmentAdd
                                        ? t('reportUsage.customerCareNotes')
                                        : isFromConsignmentBilling
                                            ? t(
                                                'reportUsage.consignmentBillingNotes'
                                            )
                                            : isFromReportUsage
                                                ? t('reportUsage.usageNotes')
                                                : t(
                                                    'scheduleSurgery.surgery.SurgeryReviewAndSuccess.customerCareSuregeryNotes'
                                                )}
                                </Title>
                                {notesData1.length > 0 ? (
                                    notesData1 &&
                                    notesData1.map((item, index) => (
                                        <React.Fragment key={index}>
                                            <MainContainerItems
                                                setMarginBottom={true}
                                                setWidth="100%"
                                                mbSetWidth="100%"
                                                borderLeft={
                                                    item.isNew &&
                                                        !isSubmitClicked
                                                        ? '2px solid #12C8F7'
                                                        : 'none'
                                                }
                                                paddingLeft="20px"
                                                marginLeft="-20px"
                                            >
                                                <div
                                                    style={{ display: 'flex' }}
                                                >
                                                    <Subtitle
                                                        showAstrisk={false}
                                                        fontSize="12px"
                                                        font={
                                                            'AvenirNextWorld Demi'
                                                        }
                                                    >
                                                        <b
                                                            style={{
                                                                marginRight:
                                                                    '10px',
                                                            }}
                                                        >
                                                            {' '}
                                                            {t(
                                                                'equity.surgery.createdBy'
                                                            )}{' '}
                                                            {displayName}{' '}
                                                        </b>{' '}
                                                    </Subtitle>
                                                    <Subtitle>
                                                        {' '}
                                                        <Bar
                                                            marginRight={'10px'}
                                                        >
                                                            |
                                                        </Bar>
                                                        {formatDateddmmmyy(
                                                            item.creationDate,
                                                            countryISOCode,
                                                            true
                                                        )}
                                                        <Bar
                                                            marginLeft={'10px'}
                                                            marginRight={'10px'}
                                                        >
                                                            |
                                                        </Bar>
                                                        {convertTime24To12(
                                                            new Date(
                                                                item.creationDate
                                                            )
                                                        )}{' '}
                                                    </Subtitle>
                                                </div>

                                                {item.typeOfNote ===
                                                    'CaseNotes' ? (
                                                    <>
                                                        {item.updatedSurgeryDate && (
                                                            <div
                                                                style={{
                                                                    fontFamily:
                                                                        'AvenirNextWorld Demi',
                                                                    color: '#202124',
                                                                    fontSize:
                                                                        '14px',
                                                                    marginBottom:
                                                                        '8px',
                                                                }}
                                                            >
                                                                {
                                                                    item.updatedSurgeryDate
                                                                }
                                                            </div>
                                                        )}

                                                        <ol
                                                            type="a"
                                                            style={{
                                                                paddingLeft:
                                                                    '16px',
                                                                color: '#202124',
                                                                fontFamily:
                                                                    'AvenirNextWorld Regular',
                                                                wordBreak:
                                                                    'break-all',
                                                                margin: '0',
                                                                fontSize:
                                                                    '15px',
                                                            }}
                                                        >
                                                            {item.note
                                                                .split(';')
                                                                .map(
                                                                    (
                                                                        element,
                                                                        index
                                                                    ) => {
                                                                        return (
                                                                            <li
                                                                                key={
                                                                                    index
                                                                                }
                                                                            >
                                                                                {
                                                                                    element
                                                                                }
                                                                            </li>
                                                                        );
                                                                    }
                                                                )}
                                                        </ol>
                                                    </>
                                                ) : (
                                                    <Subtitle>
                                                        {item.note}
                                                    </Subtitle>
                                                )}
                                            </MainContainerItems>
                                        </React.Fragment>
                                    ))
                                ) : (
                                    <div
                                        style={{
                                            fontFamily:
                                                'AvenirNextWorld Italic',
                                            fontSize: '14px',
                                            color: '#202124',
                                            opacity: '0.7',
                                        }}
                                    >
                                        {isFromConsignmentAdd || isFromEquity
                                            ? t(
                                                'reportUsage.noCustomerCareConsignmentBillingNotes'
                                            )
                                            : isFromConsignmentBilling
                                                ? t(
                                                    'reportUsage.noCustomerCareConsignmentReplenishment'
                                                )
                                                : isFromReportUsage
                                                    ? t(
                                                        'common.noCustomerCareReplenishNotes'
                                                    )
                                                    : t(
                                                        'scheduleSurgery.surgery.SurgeryReviewAndSuccess.NoSurgeryNotescreatedyet'
                                                    )}
                                    </div>
                                )}
                            </NotesContainer>

                            <VerticalLineSeperator
                                style={{
                                    display:
                                        notesData1?.length > 0 &&
                                            notesData2?.length > 0 &&
                                            !(
                                                (replenCountCons == 0 ||
                                                    replenCountUsage == 0) &&
                                                isSubmitClicked
                                            )
                                            ? null
                                            : 'none',
                                }}
                            />
                        </AccountGrid>
                        {/* {!isFromEquity &&
                        !isFromConsignmentAdd &&
                        window.innerWidth > sizes.mobileDevice && !(isFromConsignmeneBilling && replenWarning && isSubmitClicked) && (
                            <AccountGrid
                                item
                                xs={1}
                                sm={1}
                                md={1}
                                lg={1}
                                xl={1}
                                mobile
                                style={{ display: notesData1?.length <= 0 || notesData2?.length <= 0 ? "none" : null }}
                            >
                                <VerticalLineSeperator />
                            </AccountGrid>
                        )} */}
                        {!isFromEquity &&
                            !isFromConsignmentAdd &&
                            notesData2?.length > 0 &&
                            !(
                                (replenCountCons == 0 ||
                                    replenCountUsage == 0) &&
                                isSubmitClicked
                            ) && (
                                <AccountGrid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={6}
                                    lg={6}
                                    xl={6}
                                    mobile={6}
                                >
                                    <NotesContainer>
                                        <Title style={{ marginLeft: '25px' }}>
                                            {isFromConsignmentBilling
                                                ? t(
                                                    'reportUsage.consignmentReplenishmentNotes'
                                                )
                                                : isFromReportUsage
                                                    ? t('common.replenishmentNotes')
                                                    : t(
                                                        'scheduleSurgery.surgery.SurgeryNotes.surgeryNotes'
                                                    )}
                                        </Title>

                                        {replenCountCons == 0 ||
                                            replenCountUsage == 0 ? (
                                            <div
                                                style={{
                                                    marginBottom: '10px',
                                                    marginLeft: '20px',
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        color: '#ED002A',
                                                        fontSize: '13px',
                                                        fontFamily:
                                                            'AvenirNextWorld Regular',
                                                        display: 'flex',
                                                    }}
                                                >
                                                    <img
                                                        src={FlagRed}
                                                        alt="icon"
                                                        height={'20px'}
                                                        width={'20px'}
                                                    />
                                                    {t(
                                                        'common.importantMessage'
                                                    )}
                                                </span>
                                            </div>
                                        ) : null}

                                        {notesData2.length > 0 ? (
                                            notesData2 &&
                                            notesData2.map((item, index) => (
                                                <React.Fragment key={index}>
                                                    <MainContainerItems
                                                        setMarginBottom={true}
                                                        setWidth="100%"
                                                        borderLeft={
                                                            item.isNew &&
                                                                !isSubmitClicked
                                                                ? '2px solid #12C8F7'
                                                                : 'none'
                                                        }
                                                        paddingLeft="20px"
                                                        marginLeft="5px"
                                                    >
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                            }}
                                                        >
                                                            <Subtitle
                                                                showAstrisk={
                                                                    false
                                                                }
                                                                fontSize="12px"
                                                                font={
                                                                    'AvenirNextWorld Demi'
                                                                }
                                                            >
                                                                <b
                                                                    style={{
                                                                        marginRight:
                                                                            '10px',
                                                                    }}
                                                                >
                                                                    {t(
                                                                        'equity.surgery.createdBy'
                                                                    )}{' '}
                                                                    {
                                                                        displayName
                                                                    }{' '}
                                                                </b>{' '}
                                                            </Subtitle>
                                                            <Subtitle>
                                                                {' '}
                                                                <Bar
                                                                    marginRight={
                                                                        '10px'
                                                                    }
                                                                >
                                                                    |
                                                                </Bar>
                                                                {formatDateddmmmyy(
                                                                    item.creationDate,
                                                                    countryISOCode,
                                                                    true
                                                                )}
                                                                <Bar
                                                                    marginLeft={
                                                                        '10px'
                                                                    }
                                                                    marginRight={
                                                                        '10px'
                                                                    }
                                                                >
                                                                    |
                                                                </Bar>
                                                                {convertTime24To12(
                                                                    new Date(
                                                                        item.creationDate
                                                                    )
                                                                )}{' '}
                                                            </Subtitle>
                                                        </div>
                                                        {item.typeOfNote ===
                                                            'CaseNotes' ? (
                                                            <>
                                                                {item.updatedSurgeryDate && (
                                                                    <div
                                                                        style={{
                                                                            fontFamily:
                                                                                'AvenirNextWorld demi',
                                                                            color: '#202124',
                                                                            fontSize:
                                                                                '14px',
                                                                            marginBottom:
                                                                                '8px',
                                                                        }}
                                                                    >
                                                                        {
                                                                            item.updatedSurgeryDate
                                                                        }
                                                                    </div>
                                                                )}

                                                                <ol
                                                                    type="a"
                                                                    style={{
                                                                        paddingLeft:
                                                                            '16px',
                                                                        color: '#202124',
                                                                        fontFamily:
                                                                            'AvenirNextWorld Regular',
                                                                        wordBreak:
                                                                            'break-all',
                                                                        margin: '0',
                                                                        fontSize:
                                                                            '15px',
                                                                    }}
                                                                >
                                                                    {item.note
                                                                        .split(
                                                                            ';'
                                                                        )
                                                                        .map(
                                                                            (
                                                                                element,
                                                                                index
                                                                            ) => {
                                                                                return (
                                                                                    <li
                                                                                        key={
                                                                                            index
                                                                                        }
                                                                                    >
                                                                                        {
                                                                                            element
                                                                                        }
                                                                                    </li>
                                                                                );
                                                                            }
                                                                        )}
                                                                </ol>
                                                            </>
                                                        ) : (
                                                            <Subtitle>
                                                                {item.note}
                                                            </Subtitle>
                                                        )}
                                                    </MainContainerItems>
                                                </React.Fragment>
                                            ))
                                        ) : (
                                            <div
                                                style={{
                                                    fontFamily:
                                                        'AvenirNextWorld Italic',
                                                    fontSize: '14px',
                                                    color: '#202124',
                                                    opacity: '0.7',
                                                }}
                                            >
                                                {isFromConsignmentBilling
                                                    ? t(
                                                        'reportUsage.noCustomerCareConsignmentBillingNotes'
                                                    )
                                                    : isFromReportUsage
                                                        ? t(
                                                            'common.noCustomerCareUsageNotes'
                                                        )
                                                        : t(
                                                            'scheduleSurgery.surgery.SurgeryReviewAndSuccess.NoCustomeryet'
                                                        )}
                                            </div>
                                        )}
                                    </NotesContainer>
                                </AccountGrid>
                            )}
                    </>
                ) : null}
            </AccountGridContainer>
        ) : (
            <>
                {(notesData1?.length > 0 || !isSubmitClicked) && (
                    <AccountGridContainer
                        container
                        justifyContent={'space-between'}
                        direction="row"
                        isFromConsignmentBilling={isFromConsignmentBilling}
                        isCondensedView={isCondensedView}
                        isFromConsignmentAdd={isFromConsignmentAdd}
                    >
                        <AccountGrid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={12}
                            xl={12}
                            mobile={12}
                        >
                            <MainTitle
                                id={`reviewAndSubmit-notes-main-title-${isFromEquity ? 'equity' : isFromConsignmentAdd ? 'consignment-add' : isFromConsignmentBilling ? 'consignment-billing' : isFromReportUsage ? 'report-usage' : isFromSurgery ? 'surgery' : ''}`}
 mbFontSize = {isFromReportUsage && '14px'}
 mbColor = {isFromReportUsage && '#030330'}
                               
    onClick={
                                    notesData1.length > 0
                                        ? () =>
                                            toggleCard1(
                                                'itemDetails',
                                                !expandedCard1.itemDetails
                                            )
                                        : () => { }
                                }
                            >
                                {isFromEquity || isFromConsignmentAdd
                                    ? t('reportUsage.customerCareNotes')
                                    : isFromConsignmentBilling
                                        ? t('reportUsage.consignmentBillingNotes')
                                        : isFromReportUsage
                                            ? t('reportUsage.usageNotes')
                                            : t(
                                                'scheduleSurgery.surgery.SurgeryReviewAndSuccess.customerCareSuregeryNotes'
                                            )}
                                <ImageBox mbMargin = {isFromConsignmentAdd && isCondensedView && notesData1.length <= 0 && '0px 15px 0px 0px'}>
                                    {isSubmitClicked ? (
                                        // || isUsagedSubmittedSuccessfully || !restrictReviewScreen
                                        ''
                                    ) : (
                                        <ImageWrapper
                                            padding = {(isCondensedView && isFromConsignmentAdd) && '17px'}
                                            style={{
                                                marginRight:
                                                    isFromSurgery && notesData1.length > 0
                                                        ? '15px'
                                                        : isFromSurgery && !notesData1.length > 0
                                                        ? '31px'
                                                        : isFromReportUsage && notesData1.length > 0
                                                        ? '15px'
                                                        : isFromReportUsage && !notesData1.length > 0
                                                        ? '31px'
                                                        : isFromConsignmentBilling && notesData1.length > 0
                                                        ? '15px'
                                                        : isFromConsignmentBilling && !notesData1.length > 0 ? '32px' 
                                                        : isFromEquity && notesData1.length > 0 ? '20px'
                                                        : isFromEquity && !notesData1.length > 0 ? '36px'
                                                        : isFromConsignmentAdd && notesData1.length > 0 && isCondensedView ? '1.25rem'
                                                        : isFromConsignmentAdd && !notesData1.length > 0 ? isCondensedView ? '2.5rem': '2.25rem' : '13px',
                                            }}
                                        >
                                            <img
                                                id={`review-and-submit-notes-edit-icon-${isFromEquity ? 'equity' : isFromConsignmentAdd ? 'consignment-add' : isFromConsignmentBilling ? 'consignment-billing' : isFromReportUsage ? 'report-usage' : isFromSurgery ? 'surgery' : ''}`}
                                                src={Edit}
                                                onClick={() => {
                                                    try {
                                                    setViewSurgeryNotes(true);

                                                    // dispatch(
                                                    //     setProgressBarCurrentStep(
                                                    //         ORDEREQUITYSTEPS[1]
                                                    //     )
                                                    // );
                                                    // dispatch(
                                                    //     setProgressBarStatus(
                                                    //         ORDEREQUITYSTEPS[1]
                                                    //     )
                                                    // );
                                                    } catch (error) {
                                                          logErrorToConsole(error);
                                                     }
                                                }}
                                            ></img>
                                        </ImageWrapper>
                                    )}
                                    {notesData1.length > 0 && (
                                        <ImageContainer
                                            src={DownArrowFilter}
                                            alt="down-arrow"
                                            isExpanded={
                                                expandedCard1.itemDetails
                                            }
                                            id='down-arrow-icon'
                                            onClick={() =>
                                                toggleCard1(
                                                    'itemDetails',
                                                    !expandedCard1.itemDetails
                                                )
                                            }
                                            style={{
                                                marginTop: isMobileDevice()
                                                    ? ''
                                                    : '3px',
                                                marginLeft:
                                                    !isFromSurgery &&
                                                    isMobileDevice()
                                                        ? isFromConsignmentBilling
                                                            ? undefined
                                                            : !isCondensedView && isFromConsignmentAdd && isMobileDevice()
                                                                ? '7px'
                                                                : '0px'
                                                        : 'none',
                                                marginRight:
                                                    (isFromSurgery ||
                                                        isFromEquity) &&
                                                        isMobileDevice()
                                                        ? 'none'
                                                        : isFromConsignmentBilling
                                                        ? undefined
                                                        : !isCondensedView && isFromConsignmentAdd && isMobileDevice() && notesData1.length <= 0 ? '18px'
                                                        : !isCondensedView && isFromConsignmentAdd && isMobileDevice() && notesData1.length > 0 && isSubmitClicked ? '18px'
                                                        : isCondensedView && isFromConsignmentAdd && isMobileDevice() && notesData1.length > 0 && isSubmitClicked ? '38px'
                                                        : isCondensedView && isFromConsignmentAdd && isMobileDevice() ? notesData1.length <= 0 ? '22px' : '20px'
                                                            : '0px',
                                                width:
                                                    (isFromEquity ||
                                                        isFromConsignmentAdd) &&
                                                        !isMobileDevice()
                                                        ? '18px'
                                                        : isFromConsignmentBilling
                                                        ? undefined
                                                        : '',
                                                height:
                                                    (isFromEquity ||
                                                        isFromConsignmentAdd) &&
                                                        !isMobileDevice()
                                                        ? '25px'
                                                        : '',
                                                display: 'flex',
                                                // marginRight:
                                                //     window.innerWidth > sizes.mobileDevice
                                                //         ? '10px'
                                                //         : '0px',
                                            }}
                                        />
                                    )}
                                </ImageBox>
                            </MainTitle>
                        </AccountGrid>
                        {expandedCard1.itemDetails ? (
                            <>
                                <AccountGrid
                                    item
                                    xs={
                                        isFromEquity || isFromConsignmentAdd
                                            ? 12
                                            : 12
                                    }
                                    sm={
                                        isFromEquity || isFromConsignmentAdd
                                            ? 12
                                            : 5
                                    }
                                    md={
                                        isFromEquity || isFromConsignmentAdd
                                            ? 12
                                            : 5
                                    }
                                    lg={
                                        isFromEquity || isFromConsignmentAdd
                                            ? 12
                                            : 5
                                    }
                                    xl={
                                        isFromEquity || isFromConsignmentAdd
                                            ? 12
                                            : 5
                                    }
                                    mobile={
                                        isFromEquity || isFromConsignmentAdd
                                            ? 12
                                            : 5
                                    }
                                >
                                    <NotesContainer margin="15px 0 0 -20px">
                                        {notesData1.length > 0
                                            ? notesData1 &&
                                            notesData1.map((item, index) => (
                                                <React.Fragment key={index}>
                                                    <MainContainerItems
                                                        setMarginBottom={true}
                                                        setWidth="100%"
                                                        mbSetWidth="100%"
                                                        borderLeft={
                                                            item.isNew &&
                                                                !isSubmitClicked
                                                                ? '2px solid #12C8F7'
                                                                : 'none'
                                                        }
                                                        paddingLeft="20px"
                                                        marginLeft="-20px"
                                                    >
                                                        <div
                                                            style={{
                                                                display:
                                                                    'flex',
                                                            }}
                                                        >
                                                            <Subtitle
                                                                showAstrisk={
                                                                    false
                                                                }
                                                                fontSize="12px"
                                                                font={
                                                                    'AvenirNextWorld Demi'
                                                                }
                                                            >
                                                                <b
                                                                    style={{
                                                                        marginRight:
                                                                            '10px',
                                                                    }}
                                                                >
                                                                    {' '}
                                                                    {t(
                                                                        'equity.surgery.createdBy'
                                                                    )}{' '}
                                                                    {
                                                                        displayName
                                                                    }{' '}
                                                                </b>{' '}
                                                            </Subtitle>
                                                            <Subtitle width={'65%'}>
                                                                {getDisplayDate(
                                                                    item.creationDate
                                                                )}
                                                                <Bar
                                                                    marginLeft={
                                                                        '10px'
                                                                    }
                                                                    marginRight={
                                                                        '10px'
                                                                    }
                                                                >
                                                                    |
                                                                </Bar>{' '}
                                                                {convertTime24To12(
                                                                    new Date(
                                                                        item.creationDate
                                                                    )
                                                                )}{' '}
                                                            </Subtitle>
                                                        </div>
                                                        {item.typeOfNote ===
                                                            'CaseNotes' ? (
                                                            <>
                                                                {item.updatedSurgeryDate && (
                                                                    <div
                                                                        style={{
                                                                            fontFamily:
                                                                                'AvenirNextWorld demi',
                                                                            color: '#202124',
                                                                            fontSize:
                                                                                '14px',
                                                                            marginBottom:
                                                                                '8px',
                                                                        }}
                                                                    >
                                                                        {
                                                                            item.updatedSurgeryDate
                                                                        }
                                                                    </div>
                                                                )}

                                                                <ol
                                                                    type="a"
                                                                    style={{
                                                                        paddingLeft:
                                                                            '16px',
                                                                        color: '#202124',
                                                                        fontFamily:
                                                                            'AvenirNextWorld Regular',
                                                                        wordBreak:
                                                                            'break-all',
                                                                        margin: '0',
                                                                        fontSize:
                                                                            '15px',
                                                                    }}
                                                                >
                                                                    {item.note
                                                                        .split(
                                                                            ';'
                                                                        )
                                                                        .map(
                                                                            (
                                                                                element,
                                                                                index
                                                                            ) => {
                                                                                return (
                                                                                    <li
                                                                                        key={
                                                                                            index
                                                                                        }
                                                                                    >
                                                                                        {
                                                                                            element
                                                                                        }
                                                                                    </li>
                                                                                );
                                                                            }
                                                                        )}
                                                                </ol>
                                                            </>
                                                        ) : (
                                                            <Subtitle>
                                                                {item.note}
                                                            </Subtitle>
                                                        )}
                                                    </MainContainerItems>
                                                </React.Fragment>
                                            ))
                                            : null}
                                    </NotesContainer>
                                </AccountGrid>
                            </>
                        ) : null}
                    </AccountGridContainer>
                )}
                {(notesData2?.length > 0 || !isSubmitClicked) &&
                    !isFromEquity &&
                    !isFromConsignmentAdd &&
                    !(
                        (replenCountCons == 0 || replenCountUsage == 0) &&
                        isSubmitClicked
                    ) && (
                        <AccountGridContainer
                            container
                            justifyContent={'space-between'}
                            direction="row"
                            isFromConsignmentBilling={isFromConsignmentBilling}
                        >
                            <AccountGrid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                xl={12}
                                mobile={12}
                            >
                                <MainTitle
                                        mbFontSize = {isFromReportUsage && '14px'}
                                                    mbColor =  {isFromReportUsage && '#030330 !important'}
                                    id={`review-and-submit-notes-${isFromEquity ? 'equity' : isFromConsignmentAdd ? 'consignment-add' : isFromConsignmentBilling ? 'consignment-billing' : isFromReportUsage ? 'report-usage' : isFromSurgery ? 'surgery' : ''}`}
                                    onClick={() =>
                                        toggleCard2(
                                            'itemDetails',
                                            !expandedCard2.itemDetails
                                        )
                                    }
                                >
                                    {isFromConsignmentBilling
                                        ? t(
                                            'reportUsage.consignmentReplenishmentNotes'
                                        )
                                        : isFromReportUsage
                                            ? t('common.usageReplenishNotes')
                                            : t(
                                                'scheduleSurgery.surgery.SurgeryReviewAndSuccess.surgeryNotes'
                                            )}
                                    <ImageBox>
                                        {isSubmitClicked ? (
                                            // || isUsagedSubmittedSuccessfully ||!restrictReviewScreen
                                            ''
                                        ) : (
                                            <ImageWrapper
                                                style={{
                                                    marginRight:
                                                        isFromSurgery &&
                                                        notesData2.length > 0
                                                            ? '15px'
                                                            : isFromReportUsage &&
                                                              notesData2.length >
                                                                  0
                                                            ? '0px'
                                                            : isFromConsignmentBilling &&
                                                              notesData2.length >
                                                                  0
                                                            ? '15px'
                                                            : isFromEquity && notesData2.length > 0 ? '5px' : '31px',
                                                }}
                                            >
                                                <img
                                                    id={`review-submit-notes-edit-${isFromEquity ? 'equity' : isFromConsignmentAdd ? 'consignment-add' : isFromConsignmentBilling ? 'consignment-billing' : isFromReportUsage ? 'report-usage' : isFromSurgery ? 'surgery' : ''}`}
                                                    src={Edit}
                                                    onClick={() => {
                                                        try {
                                                        setViewSurgeryNotes(
                                                            true
                                                        );

                                                        // dispatch(
                                                        //     setProgressBarCurrentStep(
                                                        //         ORDEREQUITYSTEPS[1]
                                                        //     )
                                                        // );
                                                        // dispatch(
                                                        //     setProgressBarStatus(
                                                        //         ORDEREQUITYSTEPS[1]
                                                        //     )
                                                        // );
                                                        } catch (error) {
                                                           logErrorToConsole(error);
                                                         }
                                                    }}
                                                ></img>
                                            </ImageWrapper>
                                        )}
                                        {notesData2.length > 0 && (
                                            <ImageContainer
                                                src={DownArrowFilter}
                                                alt="down-arrow"
                                                isExpanded={
                                                    expandedCard2.itemDetails
                                                }
                                                id='downArrow-icon'
                                                onClick={() =>
                                                    toggleCard2(
                                                        'itemDetails',
                                                        !expandedCard2.itemDetails
                                                    )
                                                }
                                                style={{
                                                    marginTop: isMobileDevice()
                                                        ? ''
                                                        : '3px',
                                                    marginLeft:
                                                        !isFromSurgery &&
                                                        isMobileDevice()
                                                            ? isFromConsignmentBilling
                                                                ? undefined
                                                                : '15px'
                                                            : 'none',
                                                    marginRight:
                                                        isFromConsignmentBilling &&
                                                        isMobileDevice()
                                                            ? undefined
                                                            : 'none',
                                                    width:
                                                        (isFromEquity ||
                                                            isFromConsignmentAdd) &&
                                                            !isMobileDevice()
                                                            ? '18px'
                                                            : isFromConsignmentBilling
                                                            ? undefined
                                                            : '',
                                                    height:
                                                        (isFromEquity ||
                                                            isFromConsignmentAdd) &&
                                                            !isMobileDevice()
                                                            ? '25px'
                                                            : '',
                                                    display: 'flex',
                                                    // marginRight:
                                                    //     window.innerWidth > sizes.mobileDevice
                                                    //         ? '10px'
                                                    //         : '0px',
                                                }}
                                            />
                                        )}
                                    </ImageBox>
                                </MainTitle>
                            </AccountGrid>
                            {expandedCard2.itemDetails &&
                                !(
                                    (replenCountCons == 0 ||
                                        replenCountUsage == 0) &&
                                    isSubmitClicked
                                ) ? (
                                <>
                                    {!isFromEquity && !isFromConsignmentAdd && (
                                        <AccountGrid
                                            item
                                            xs={12}
                                            sm={5}
                                            md={5}
                                            lg={5}
                                            xl={5}
                                            mobile={5}
                                        >
                                            {replenCountCons == 0 ||
                                                replenCountUsage == 0 ? (
                                                <div>
                                                    <span
                                                        style={{
                                                            color: '#ED002A',
                                                            fontSize: '13px',
                                                            fontFamily:
                                                                'AvenirNextWorld Regular',
                                                            display: 'flex',
                                                        }}
                                                    >
                                                        <img
                                                            src={FlagRed}
                                                            alt="icon"
                                                            height={'20px'}
                                                            width={'20px'}
                                                        />
                                                        {t(
                                                            'common.importantMessage'
                                                        )}
                                                    </span>
                                                </div>
                                            ) : null}
                                            <NotesContainer margin="15px 0 0 -20px">
                                                {notesData2.length > 0
                                                    ? notesData2 &&
                                                    notesData2.map(
                                                        (item, index) => (
                                                            <React.Fragment
                                                                key={index}
                                                            >
                                                                <MainContainerItems
                                                                    setMarginBottom={
                                                                        true
                                                                    }
                                                                    mbSetWidth="100%"
                                                                    borderLeft={
                                                                        item.isNew &&
                                                                            !isSubmitClicked
                                                                            ? '2px solid #12C8F7'
                                                                            : 'none'
                                                                    }
                                                                    paddingLeft="20px"
                                                                    marginLeft="-20px"
                                                                >
                                                                    <div
                                                                        style={{
                                                                            display:
                                                                                'flex',
                                                                        }}
                                                                    >
                                                                        <Subtitle
                                                                            showAstrisk={
                                                                                false
                                                                            }
                                                                            fontSize="12px"
                                                                            font={
                                                                                'AvenirNextWorld Demi'
                                                                            }
                                                                        >
                                                                            <b
                                                                                style={{
                                                                                    marginRight:
                                                                                        '10px',
                                                                                }}
                                                                            >
                                                                                {t(
                                                                                    'equity.surgery.createdBy'
                                                                                )}{' '}
                                                                                {
                                                                                    displayName
                                                                                }{' '}
                                                                            </b>{' '}
                                                                        </Subtitle>
                                                                        <Subtitle width={'65%'}>
                                                                            {getDisplayDate(
                                                                                item.creationDate
                                                                            )}
                                                                            <Bar
                                                                                marginLeft={
                                                                                    '10px'
                                                                                }
                                                                                marginRight={
                                                                                    '10px'
                                                                                }
                                                                            >
                                                                                |
                                                                            </Bar>{' '}
                                                                            {convertTime24To12(
                                                                                new Date(
                                                                                    item.creationDate
                                                                                )
                                                                            )}{' '}
                                                                        </Subtitle>
                                                                    </div>
                                                                    {item.typeOfNote ===
                                                                        'CaseNotes' ? (
                                                                        <>
                                                                            {item.updatedSurgeryDate && (
                                                                                <div
                                                                                    style={{
                                                                                        fontFamily:
                                                                                            'AvenirNextWorld demi',
                                                                                        color: '#202124',
                                                                                        fontSize:
                                                                                            '14px',
                                                                                        marginBottom:
                                                                                            '8px',
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        item.updatedSurgeryDate
                                                                                    }
                                                                                </div>
                                                                            )}

                                                                            <ol
                                                                                type="a"
                                                                                style={{
                                                                                    paddingLeft:
                                                                                        '16px',
                                                                                    color: '#202124',
                                                                                    fontFamily:
                                                                                        'AvenirNextWorld Regular',
                                                                                    wordBreak:
                                                                                        'break-all',
                                                                                    margin: '0',
                                                                                    fontSize:
                                                                                        '15px',
                                                                                }}
                                                                            >
                                                                                {item.note
                                                                                    .split(
                                                                                        ';'
                                                                                    )
                                                                                    .map(
                                                                                        (
                                                                                            element,
                                                                                            index
                                                                                        ) => {
                                                                                            return (
                                                                                                <li
                                                                                                    key={
                                                                                                        index
                                                                                                    }
                                                                                                >
                                                                                                    {
                                                                                                        element
                                                                                                    }
                                                                                                </li>
                                                                                            );
                                                                                        }
                                                                                    )}
                                                                            </ol>
                                                                        </>
                                                                    ) : (
                                                                        <Subtitle>
                                                                            {
                                                                                item.note
                                                                            }
                                                                        </Subtitle>
                                                                    )}
                                                                </MainContainerItems>
                                                            </React.Fragment>
                                                        )
                                                    )
                                                    : null}
                                            </NotesContainer>
                                        </AccountGrid>
                                    )}
                                </>
                            ) : null}
                        </AccountGridContainer>
                    )}
            </>
        )
    ) : null;
};

export default ReviewAndSubmitNotes;
